import React, { useEffect, useRef, useState } from "react";
import LogoImage from "../../assets/images/wannaeat_logo.png";
import {
  CompletedOrderURL,
  OpenOrderURL,
  OrderPrepareURL,
  UpdateOrderURL,
  LoginChefURL,
  CanceledOrderURL
} from "../../component/config/config";
import { Dialog } from "@mui/material";
import { ImageURL } from "../../component/config/config";
import { AcceptOrderURL } from "../../component/config/config";
import { RejectOrderURL } from "../../component/config/config";
import moment from "moment";
import Pagination from "./Pagination";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { tostS, tostE } from "../../toast";
import * as Yup from "yup";
import { useFormik } from "formik";
import axiosInstance from "../config/axios";
import { db } from "../config/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp
} from "firebase/firestore";
import Select from "react-select";
import DeliveryDashboard from "./DeliveryDashboard";


const NewOrder = () => {
  const current_date = new Date();
  const [isDisabled, setIsDisabled] = useState(false);
  const { type } = useParams();
  const LoginData = useSelector((state) =>
    state.login.data && state.login.data.chefDetails
      ? state.login.data.chefDetails._id
      : null
  );
  const LoginDataa = useSelector((state) =>
    state.login.data && state.login.data.chefDetails ? state.login.data : {}
  );
  const location = useLocation();
  const PostPerPage = JSON.parse(localStorage.getItem("pageSize"));
  const [uniqueDates, setUniqueDates] = useState([]);
  const [selectedDateIndex, setSelectedDateIndex] = useState(0);
  const [filteredOpenOrders, setFilteredOpenOrders] = useState([]);
  //For Dialog box to click on next button
  const [currentTab, setCurrentTab] = useState(type);
  const [newOrder, setNewOrder] = useState([]);
  const [order, setOrder] = useState([]);
  const [completedOrder, setCompletedOrder] = useState([]);
  const [canceledOrder, setCanceledOrder] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState();
  const [totalData, setTotalData] = useState(0);
  const [food, setFood] = useState([]);
  const [search, setSearch] = useState("");
  const [isScrollLocked, setIsScrollLocked] = useState(false);
  const [error, setError] = useState({
    reason: false,
  });
  const [rejection, setRejection] = useState({
    id: "",
    reason: "",
  });
  const [open, setOpen] = useState(false);
  const handleClickOpen = (ids) => {
    setOpen(true);
    setFieldValue("id", ids);
  };

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
  };

  const [print, setPrint] = useState({
    show: false,
    data: [],
    type: 'single'
  });


  const [active, setActive] = useState(false);

  const handleOpenSinglePrint = (data) => {
    setIsScrollLocked(true);
    setPrint({
      show: true,
      data: [data],
      type: 'single'
    });
  };

  const handleOpenBulkPrint = () => {
    if (filteredOpenOrders.length === 0) {
      tostE("No orders to print for this date.");
      return;
    }
    setIsScrollLocked(true);
    setPrint({
      show: true,
      data: filteredOpenOrders,
      type: 'bulk'
    });
  };

  const handleClickClose = () => {
    setIsScrollLocked(false);
    setPrint({
      show: false,
      data: [],
      type: 'single'
    });
  };

  const handleChat = async (ord) => {
    try {
      let chefId = ord.chefId._id;
      let chefFullName = ord.chefId.fullName;
      let chefProfileImage = LoginDataa?.chefDetails?.profileImage || null;
      let userId = ord.userId._id;
      let userFullName = ord.userId.fullName;
      const roomsCollection = collection(db, 'rooms');
      const q = query(
        roomsCollection,
        where('firstUserId', '==', userId),
        where('secondUserId', '==', chefId)
      );

      const querySnapshot = await getDocs(q);
      let roomId;

      if (!querySnapshot.empty) {
        roomId = querySnapshot.docs[0].id;
      } else {
        const newRoomRef = await addDoc(roomsCollection, {
          firstUserId: userId,
          secondUserId: chefId,
          firstUserName: userFullName,
          secondUserName: chefFullName,
          firstUserProfileImage: false,
          secondUserProfileImage: chefProfileImage,
          timestamp: serverTimestamp()
        });
        roomId = newRoomRef.id;
      }

      navigate("/dashboard/mychats", {
        state: {
          userId: chefId,
          roomId: roomId
        }
      });

    } catch (error) {
      console.error("Error in handleChat:", error);
    }
  }

  useEffect(() => {
    if (currentTab === "open" && order.length > 0) {
      const dates = [...new Set(order.map(o => moment(o.dishData[0].scheduledDate).format("YYYY-MM-DD")))].sort();
      setUniqueDates(dates);

      const today = moment().format("YYYY-MM-DD");
      const todayIndex = dates.indexOf(today);

      if (todayIndex !== -1) {
        setSelectedDateIndex(todayIndex);
      } else if (dates.length > 0) {
        setSelectedDateIndex(0);
      }
    }
  }, [order, currentTab]);

  useEffect(() => {
    if (currentTab === "open" && uniqueDates.length > 0) {
      const targetDate = uniqueDates[selectedDateIndex];
      const filtered = order.filter(o => moment(o.dishData[0].scheduledDate).format("YYYY-MM-DD") === targetDate);
      setFilteredOpenOrders(filtered);
    } else if (currentTab === "open") {
      setFilteredOpenOrders([]);
    }
  }, [selectedDateIndex, uniqueDates, order, currentTab]);

  const handleDateDropdown = (e) => {
    const idx = uniqueDates.indexOf(e.target.value);
    if (idx !== -1) setSelectedDateIndex(idx);
  };

  const handlePrevDate = () => {
    if (selectedDateIndex > 0) setSelectedDateIndex(prev => prev - 1);
  };

  const handleNextDate = () => {
    if (selectedDateIndex < uniqueDates.length - 1) setSelectedDateIndex(prev => prev + 1);
  };

const triggerPrintWindow = (ordersToPrint) => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let labelsHTML = ordersToPrint
      .map((ord) => {
        const address = ord.userAddress
          ? `${ord.userAddress.add1}, ${ord.userAddress.city}, ${ord.userAddress.zip}`
          : "";
        const phone = ord.userId?.phoneNumber
          ? `+1 (${ord.userId.phoneNumber.slice(0, 3)}) ${ord.userId.phoneNumber.slice(3, 6)}-${ord.userId.phoneNumber.slice(6)}`
          : "N/A";

        return `
        <div class="label-wrapper">
          <div class="label-card">
              <div style="text-align: center; margin-bottom: 15px;">
                 <img src="${window.location.origin}${LogoImage}" style="height: 50px; width: auto;" alt="Logo"/>
              </div>
              <div class="content-top">
                  <div class="header-row">
                       <span class="order-id">Order #: ${ord.orderId}</span>
                       <span class="badge">${ord.deliveryPreference}</span>
                  </div>
                  
                  <h2 class="customer-name" style="margin-top: 15px; font-size: 22px;">${ord.userId?.fullName}</h2>
                  
                  <hr class="divider" style="margin: 10px 0;" />
                  
                  <div class="info-group">
                      <p style="margin-bottom: 2px;"><strong>Delivery Address:</strong> ${address}</p>
                      <p style="margin-top: 2px;"><strong>Date:</strong> ${moment(ord.dishData[0].scheduledDate).format("Do MMM YYYY")}</p>
                      <p style="margin-top: 2px;"><strong>Delivery Time:</strong> ${ord.deliveryOrPickupWindow}</p>
                      <p style="margin-top: 2px;"><strong>Phone:</strong> ${phone}</p>
                  </div>
                  
                  <hr class="divider" style="margin: 5px 0;" />

                  <div class="order-details">
                      <h6 class="details-heading">Order Details</h6>
                      <p class="chef-name">Chef: ${ord.chefId?.firstName}</p>
                      
                      <div class="table-wrapper">
                          <table class="dish-table">
                              <thead>
                                  <tr>
                                      <th>Dish Name</th>
                                      <th style="text-align:right;">Quantity</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  ${ord.dishData.map((dish) => `
                                      <tr>
                                          <td>${dish.dishName}</td>
                                          <td style="text-align:right;">${dish.qty}</td>
                                      </tr>
                                  `).join("")}
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
              
              <div class="footer-section">
                  <div class="footer">
                      <p>Thank you for your order! Enjoy your meal 🍽️</p>
                  </div>
                  <div class="website-link">
                      <small>www.WannaEat.com</small>
                  </div>
              </div>
          </div>
        </div>
       `;
      })
      .join("");

    const printStyles = `
            * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                box-sizing: border-box;
            }

            @page {
                size: A4 portrait;
                margin: 10mm;
                @bottom-right {
                    content: "Page " counter(page) " of " counter(pages);
                    font-size: 13px;
                    color: #000;
                }
                @top-left {
                    content: "${moment().format("MM/DD/YYYY")}";
                    font-size: 13px;
                    color: #000;
                }
                @top-center {
                    content: "WannaEat";
                    font-size: 16px;
                    font-weight: bold;
                    color: #000;
                }
            }

            body { 
                font-family: sans-serif; 
                background: #fff; 
                margin: 0; 
                padding: 10px;
            }

            .grid-container {
                display: block;
                column-count: 2; 
                column-gap: 15px;
                width: 100%;
            }

            .label-wrapper {
                width: 100%;
                display: inline-block; 
                margin-bottom: 15px;   
                break-inside: avoid;   
                page-break-inside: avoid; 
            }

            .label-card {
                border: 2px dashed #5c5c5cff; 
                border-radius: 12px;
                padding: 15px;
                background: #fff;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .header-row { 
                display: flex; 
                justify-content: space-between; 
                align-items: center; 
                margin-bottom: 5px; 
            }
            .order-id { font-size: 14px; font-weight: bold; }
            .badge { background: #ee2982 !important; color: white !important; padding: 4px 10px; border-radius: 20px; font-weight: bold; font-size: 11px; }

            .customer-name { font-size: 22px; font-weight: 800; text-align: center; line-height: 1.1; }
            
            .divider { border: 0; border-top: 2px solid #727272ff; }
            
            .info-group { font-size: 13px; line-height: 1.3; }
            .info-group p { margin: 0; }
            
            .order-details { margin-top: 5px; flex-grow: 1; }
            
            .details-heading { 
                margin: 0 0 2px 0; 
                font-size: 14px; 
                font-weight: 800; 
                text-transform: uppercase;
            }
            
            .chef-name { 
                margin: 0 0 5px 0; 
                font-size: 12px;
                color: #333;
                font-weight: 600;
            }

            .table-wrapper {
                border-radius: 6px;
                overflow: hidden;
                border: 1px solid #5c5c5cff;
                width: 100%;
                margin-bottom: 10px; 
            }

            .dish-table { 
                width: 100%; 
                border-collapse: collapse; 
                font-size: 12px; 
            } 

            .dish-table thead { 
                background: #f4edf1 !important; 
            }

            .dish-table th { 
                padding: 5px; 
                border-bottom: 1px solid #5c5c5cff; 
                background: #f4edf1 !important; 
                font-weight: bold;
                text-align: left;
            }

            .dish-table td { 
                padding: 5px; 
                border-bottom: 1px solid #5c5c5cff; 
            }

            .footer-section { margin-top: auto; }
            .footer { text-align: center; background: #f4edf1 !important; padding: 6px; border-radius: 8px; }
            .footer p { margin: 0; font-size: 11px; font-weight: 600; }
            
            .website-link { text-align: center; margin-top: 2px; font-weight: bold; font-size: 10px; }

            @media print {
              body { margin: 0; padding: 0; }
              .grid-container { column-count: 2; }
            }
        `;

    const fullHTML = `
    <!DOCTYPE html>
    <html>
    <head>
          <title>WannaEat - Print Labels</title>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>${printStyles}</style>
    </head>
    <body>
        <div class="grid-container">
            ${labelsHTML}
        </div>
    </body>
    </html>
    `;

    if (isMobile) {
      const iframe = document.createElement("iframe");
      iframe.id = "mobile-print-iframe";
      iframe.style.position = "fixed";
      iframe.style.top = "0";
      iframe.style.left = "0";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.style.zIndex = "999999";
      iframe.style.background = "#fff";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(fullHTML);
      doc.close();

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          const existingIframe = document.getElementById("mobile-print-iframe");
          if (existingIframe) {
            document.body.removeChild(existingIframe);
          }
        }, 1000);
      }, 500);
    } else {
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(fullHTML);
      doc.close();

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 500);
    }
  };

  const paginate = (pageNumber) => {
    if (type == "open") {
      fetchData(pageNumber);
    }
    if (type == "completed") {
      completeOrder(pageNumber);
    }
    if (type == "food") {
      foodPrepare(pageNumber);
    }
    if (type == "canceled") {
      cancelOrder(pageNumber);
    }
    setCurrentPage(pageNumber);
  };
  const onNext = () => {
    setCurrentPage(currentPage + 1);
    if (type == "open") {
      fetchData(currentPage + 1);
    }
    if (type == "completed") {
      completeOrder(currentPage + 1);
    }
    if (type == "food") {
      foodPrepare(currentPage + 1);
    }
    if (type == "canceled") {
      cancelOrder(currentPage + 1);
    }
  };

  const onPrevious = () => {
    setCurrentPage(currentPage - 1);
    if (type == "open") {
      fetchData(currentPage - 1);
    }
    if (type == "completed") {
      completeOrder(currentPage - 1);
    }
    if (type == "food") {
      foodPrepare(currentPage - 1);
    }
    if (type == "canceled") {
      cancelOrder(currentPage - 1);
    }
  };
  const options = Intl.DateTimeFormat().resolvedOptions();
  const timezone = options.timeZone;

  const fetchData = async (currentPage, searchString) => {
    document.body.classList.add("loading-indicator");
    setLoading(true);
    try {
      const pageSizeToUse = type === 'open' ? 500 : (PostPerPage ? PostPerPage : postsPerPage);

      const response = await axiosInstance().post(OpenOrderURL, {
        pageSize: pageSizeToUse,
        pageNumber: currentPage,
        searchItem: searchString,
      });
      const d = response.data.data;
      document.body.classList.remove("loading-indicator");
      setOrder(d);

      setTotalData(response.data.total_records);
      setLoading(false);
      setIsScrollLocked(false)
    } catch (error) {
      setLoading(false);
      document.body.classList.remove("loading-indicator");
    }
  };
  const [updat, setUpdat] = useState();
  const update = (ids, statu) => {
    setIsScrollLocked(true);
    axiosInstance()
      .post(UpdateOrderURL, { id: ids, status: statu })

      .then((up) => {
        if (up.status === 200) {
          tostS(up.data.message);
          fetchData(currentPage);
        }
      })
      .catch((error) => {
        tostE(error.up.data.message);
      });;
  };
  const completeed = (ids, statu) => {
    setIsScrollLocked(true)
    axiosInstance()
      .post(UpdateOrderURL, { id: ids, status: statu })

      .then((up) => {
        if (up.status === 200) {
          tostS(up.data.message);
          if (order.length > 1) {
            fetchData(currentPage);
            setCurrentPage(currentPage);
          } else {
            fetchData(currentPage - 1);
            setCurrentPage(currentPage - 1);
          }
        }
      })
      .catch((error) => {
        tostE(error.up.data.message);
      });
  };

  const completeOrder = async (currentPage, searchString) => {
    document.body.classList.add("loading-indicator");
    setLoading(true);
    try {
      const x = await axiosInstance().post(CompletedOrderURL, {
        pageSize: PostPerPage ? PostPerPage : postsPerPage,
        pageNumber: currentPage,
        searchItem: searchString,
      });
      document.body.classList.remove("loading-indicator");
      setCompletedOrder(x.data.data);
      setTotalData(x.data.total_records);
      tostS(x.data.message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      document.body.classList.remove("loading-indicator");
      tostE(error.x.data.message);
    }
  };
  const foodPrepare = async (currentPage, searchString) => {
    document.body.classList.add("loading-indicator");

    setLoading(true);
    try {
      const re = await axiosInstance().post(OrderPrepareURL, {
        pageSize: PostPerPage ? PostPerPage : postsPerPage,
        pageNumber: currentPage,
        searchItem: searchString,
        chefId: LoginData,
        timezone: timezone,
      });
      const z = re.data.data;
      setTotalData(re.data.total_records);
      document.body.classList.remove("loading-indicator");
      setFood(z);
      tostS(z.message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      document.body.classList.remove("loading-indicator");
      tostE(error.z.data.message);
    }
  };
  const getData = async () => {
    document.body.classList.add("loading-indicator");
    try {
      const response = await axiosInstance().get(LoginChefURL, {});
      localStorage.setItem("pageSize", response?.data?.data?.pageSize);
      setPostsPerPage(response?.data?.data?.pageSize);
    } catch (error) {
      document.body.classList.remove("loading-indicator");
    }
  };

  const cancelOrder = async (currentPage, searchString) => {

    document.body.classList.add("loading-indicator");
    setLoading(true);
    try {
      const cancelledorder = await axiosInstance().post(CanceledOrderURL, {
        pageSize: PostPerPage ? PostPerPage : postsPerPage,
        pageNumber: currentPage,
        searchItem: searchString,
      });
      document.body.classList.remove("loading-indicator");
      setCanceledOrder(cancelledorder.data.data);
      setTotalData(cancelledorder.data.total_records);
      tostS(cancelledorder.data.message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      document.body.classList.remove("loading-indicator");
      tostE(error.x.data.message);
    }
  };

useEffect(() => {
    if (type === 'delivery') return;
    const actionMap = {
      open: fetchData,
      food: foodPrepare,
      completed: completeOrder,
      canceled: cancelOrder,
    };

    actionMap[type]?.(currentPage);
    getData();
  }, [type]);

  //Get current Posts
  const indexOfLastPost = currentPage * PostPerPage;
  const indexOfFirstPost = indexOfLastPost - PostPerPage;

  const accept = (id) => {
    axiosInstance()
      .post(AcceptOrderURL, { id: id })
      .then((re) => {
        if (re.status === 200) {
          tostS(re.data.message);
        }
      })
      .catch((error) => {
        tostE(error.re.data.message);
      });
  };
  const validationSchema = Yup.object().shape({
    reason: Yup.string()
      .min(5, " Reason must be at least 5 characters ")
      .max(750, "Reason cannot be more than 750 characters ")
      .required("Reason is required"),
  });
  const formik = useFormik({
    initialValues: {
      reason: "",
      id: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const respon = await axiosInstance().post(RejectOrderURL, values);
        if (respon.status === 200) {
          const messa = respon.data.message;
          setOpen(false);
          resetForm();
          tostS(messa);
        }
      } catch (error) {
        setIsDisabled(false);
        tostE(error.respon.data.messsage);
      }
    },
  });

  const handleSearch = (e) => {
    e.preventDefault();

    let searchString = e.target.value;

    if (currentTab === "open") {
      fetchData(currentPage, searchString);
    }
    if (currentTab === "complete") {
      completeOrder(currentPage, searchString);
    }
    if (currentTab === "food") {
      foodPrepare(currentPage, searchString);
    }
    if (currentTab === "canceled") {
      cancelOrder(currentPage, searchString);
    }
    setSearch(searchString);
    setCurrentPage(1);
  };

  let {
    submitCount,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    values,
    setValues,
  } = formik;

  const navigate = useNavigate();
  const deliveryDash = () => {
    navigate("/dashboard/myorder/delivery");
  };

  const tod = () => {
    navigate("/dashboard/myorder/new");
  };
  const ope = () => {
    navigate("/dashboard/myorder/open");
    setCurrentTab("open");
    setCurrentPage(1);
  };
  const foo = () => {
    navigate("/dashboard/myorder/food");
    setCurrentTab("food");
    setCurrentPage(1);
  };
  const com = () => {
    navigate("/dashboard/myorder/completed");
    setCurrentTab("complete");
    setCurrentPage(1);
  };
  const cancel = () => {
    navigate("/dashboard/myorder/canceled");
    setCurrentTab("cancel");
    setCurrentPage(1);
  };
  const dateOptions = uniqueDates.map((d) => ({
    value: d,
    label: moment(d).format("ddd, Do MMM YYYY"),
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#8d126e",
      borderRadius: "8px",
      minHeight: "45px",
      minWidth: "220px",
      boxShadow: state.isFocused ? "0 0 0 1px #8d126e" : "none",
      "&:hover": {
        borderColor: "#8d126e",
      },
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#8d126e"
        : state.isFocused
          ? "#f3e5f5"
          : undefined,
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#f3e5f5",
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#8d126e",
      fontWeight: "bold",
      fontSize: "15px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#8d126e",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      border: "1px solid #8d126e",
      marginTop: "2px",
      boxShadow: "none"
    }),
  };

  return (
    <>
      <div className="dash-R">
        <div className="dash-head">
          <h3>my orders</h3>
        </div>
        <div className="dash-bottom mt-2 my-orders">
          <div className="my-orders-head d-flex align-items-center justify-content-between">
            <ul className="nav nav-tabs my-orders-tabs">
              <li className="nav-item">
                <button
                  onClick={() => {
                    ope();
                    setCurrentTab("open");
                    setCurrentPage(1);
                  }}
                  className={"nav-link" + (type == "open" ? " active" : "")}
                  id="tab-2"
                  type="button"
                >
                  Open Orders
                </button>
              </li>

               <li className="nav-item">
        <button
          onClick={() => {
            deliveryDash();
            setCurrentTab("delivery");
          }}
          className={"nav-link" + (type == "delivery" ? " active" : "")}
          id="tab-delivery"
          type="button"
        >
          Delivery Dashboard
        </button>
    </li>

              <li className="nav-item">
                <button
                  onClick={() => {
                    foo();
                    setCurrentTab("food");
                    setCurrentPage(1);
                  }}
                  className={"nav-link" + (type == "food" ? " active" : "")}
                  id="tab-3"
                  type="button"
                >
                  Food Preparation
                </button>
              </li>
              <li className="nav-item">
                <button
                  onClick={() => {
                    com();
                    setCurrentTab("complete");
                    setCurrentPage(1);
                  }}
                  className={
                    "nav-link" + (type == "completed" ? " active" : "")
                  }
                  id="tab-4"
                  type="button"
                >
                  Completed Orders
                </button>
              </li>
              <li className="nav-item">
                <button
                  onClick={() => {
                    cancel();
                    setCurrentTab("cancel");
                    setCurrentPage(1);
                  }}
                  className={"nav-link" + (type == "canceled" ? " active" : "")}
                  id="tab-5"
                  type="button"
                >
                  Canceled Orders
                </button>
              </li>
            </ul>
          </div>
         <div className="my-orders-body">
    {type === "delivery" ? (
      <DeliveryDashboard />
    ) : (
      <>
            {totalData === 0 ? <h3>NO DATA AVAILABLE</h3> : ""}
            <div className="tab-content">
              {/* //For Open orders */}
              <div
                className={
                  "tab-pane fade" + (type === "open" ? " show active" : "")
                }
                id="open-order"
                role="tabpanel"
                aria-labelledby="tab-2"
              >
                {uniqueDates.length > 0 && (
                  <div
                    className="orders-date-header mb-4 mt-3 pb-3"
                    style={{ borderBottom: "1px solid #ddd" }}
                  >
                    <div className="orders-date-header-row">
                      {/* Date Dropdown Group */}
                      <div className="orders-date-dropdown-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            fontSize: "18px",
                            color: "#8d126e",
                          }}
                        >
                          Date:
                        </label>

                        <Select
                          options={dateOptions}
                          value={
                            uniqueDates.length > 0
                              ? {
                                value: uniqueDates[selectedDateIndex],
                                label: moment(
                                  uniqueDates[selectedDateIndex]
                                ).format("ddd, Do MMM YYYY"),
                              }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const idx = uniqueDates.indexOf(selectedOption.value);
                            if (idx !== -1) setSelectedDateIndex(idx);
                          }}
                          styles={customStyles}
                          isSearchable={false}
                        />
                      </div>

                      {/* Arrows Group */}
                      <div className="orders-arrows-group">
                        <i
                          className="ri-arrow-left-s-line"
                          style={{
                            fontSize: "32px",
                            color: selectedDateIndex <= 0 ? "#ccc" : "#8d126e",
                            cursor:
                              selectedDateIndex <= 0 ? "default" : "pointer",
                            fontWeight: "100",
                          }}
                          onClick={handlePrevDate}
                        ></i>
                        <i
                          className="ri-arrow-right-s-line"
                          style={{
                            fontSize: "32px",
                            color:
                              selectedDateIndex >= uniqueDates.length - 1
                                ? "#ccc"
                                : "#8d126e",
                            cursor:
                              selectedDateIndex >= uniqueDates.length - 1
                                ? "default"
                                : "pointer",
                            fontWeight: "100",
                          }}
                          onClick={handleNextDate}
                        ></i>
                      </div>

                      {/* Page Info + Print Button Group */}
                      <div className="orders-page-print-group">
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#333",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Page{" "}
                          <span style={{ fontWeight: "bold", color: "#8d126e" }}>
                            {uniqueDates.length > 0 ? selectedDateIndex + 1 : 0}
                          </span>{" "}
                          of {uniqueDates.length}
                        </span>

                        <button
                          className="btn orders-print-all-btn"
                          style={{
                            borderRadius: "5px",
                            fontSize: "14px",
                            backgroundColor: "#8d126e",
                            color: "white",
                            whiteSpace: "nowrap",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={handleOpenBulkPrint}
                        >
                          Print All Labels
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {Object.entries(
                  filteredOpenOrders.reduce((acc, ord) => {
                    const window = ord.deliveryOrPickupWindow;
                    const date = moment(ord.dishData[0].scheduledDate).format(
                      "Do MMM YYYY"
                    );

                    if (!acc[date]) {
                      acc[date] = {};
                    }

                    if (!acc[date][window]) {
                      acc[date][window] = [];
                    }

                    acc[date][window].push(ord);
                    return acc;
                  }, {})
                ).map(([date, windows]) => (
                  <div key={date} className="scheduled-date-group">
                    {Object.entries(windows)
                      .sort(([a], [b]) => {
                        if (a === "10am-1pm") return -1;
                        if (b === "10am-1pm") return 1;
                        if (a === "4pm-7pm") return 1;
                        if (b === "4pm-7pm") return -1;
                        return 0;
                      })
                      .map(([window, orders]) => (
                        <div
                          key={window}
                          className="delivery-pickup-window-group"
                        >
                          {orders.map((ord, i) => (
                            <div
                              className="accordion dash-accordion"
                              id={`accordion${i}`}
                              key={i}
                            >
                              <div className="my-order-title mt-4">
                                <h3
                                  className="my-orders-title"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {date}
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  {window === "10am-1pm" ? "Lunch" : "Dinner"}
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
                                  Delivery&nbsp;/&nbsp;Pick-Up Window: {window}
                                </h3>
                              </div>
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id={`heading${i}`}
                                >
                                  <div className="dish-head">
                                    <div className="title-timer">
                                      <small>
                                        #{ord.orderId}{" "}
                                        <b>
                                          {ord.orderPortion
                                            ? ` (${ord.orderPortion})`
                                            : ""}
                                        </b>
                                      </small>
                                    </div>
                                  </div>
                                  <ul className="Dishes-list dishes-list-edit">
                                    {ord.dishData.map((daa) => (
                                      <li key={daa._id}>
                                        <figure className="Dishes-list-L">
                                          <img
                                            src={
                                              ImageURL + daa.dishId?.dishImage
                                            }
                                            alt={daa?.dishName}
                                          />
                                        </figure>
                                        <figcaption className="Dishes-list-R">
                                          <h4>{daa.dishName}</h4>
                                          <span className="pb-2">
                                            <b>Qty:</b> {daa.qty}
                                          </span>
                                          <br />
                                          <span>
                                            <b>Type:</b> {ord.orderType}
                                          </span>
                                        </figcaption>
                                      </li>
                                    ))}
                                  </ul>
                                </h2>
                                <div
                                  id={`collapse${i}`}
                                  className="accordion-collapse"
                                  aria-labelledby={`heading${i}`}
                                  data-bs-parent={`#accordion${i}`}
                                >
                                  <div className="accordion-body">
                                    <ul className="Delivery-content">
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Delivery Preference:</b>{" "}
                                        {ord.deliveryPreference}
                                      </li>
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Delivery / Pick up Window:</b>{" "}
                                        {ord.deliveryOrPickupWindow}
                                      </li>
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Customer Name:</b>{" "}
                                        {ord?.userId?.fullName}
                                      </li>
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Order Placement Date:</b>{" "}
                                        {moment(ord.placeOrderDate).format(
                                          "Do MMM YYYY"
                                        )}
                                      </li>
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Spice Level:</b>{" "}
                                        {ord.spiceLevel}
                                      </li>
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Spice Level:</b> {ord.spiceLevel}
                                      </li>
                                      <li
                                        className="me-2"
                                        style={{ listStyleType: "none" }}
                                      >
                                        <b>Order Instructions:</b>{" "}
                                        {ord.orderInstructions}
                                      </li>
                                    </ul>
                                    <div className="mt-4 d-flex three-combine-btn">
                                      {moment(current_date).format(
                                        "Do MMM YYYY"
                                      ) ===
                                        moment(
                                          ord.dishData[0].scheduledDate
                                        ).format("Do MMM YYYY") ? (
                                        <>
                                          <a
                                            className={
                                              active
                                                ? "step-button btn black-btn min-height hvr-sweep-to-right me-3"
                                                : "step-button btn purple-btn min-height hvr-sweep-to-right me-3"
                                            }
                                            data-bs-toggle="modal"
                                            data-bs-target="#Print-label"
                                            onClick={() =>
                                              handleOpenSinglePrint(ord)
                                            }
                                          >
                                            1. Print Label
                                          </a>
                                          <a
                                            className={
                                              ord.status === 1
                                                ? "step-button btn min-height me-3 disbled-btn"
                                                : "step-button btn pink-btn min-height hvr-sweep-to-right me-3"
                                            }
                                            onClick={() =>
                                              ord.status !== 1 &&
                                              update(ord._id, 1)
                                            }
                                          >
                                            2. Order Ready
                                          </a>
                                        </>
                                      ) : (
                                        <>
                                          <a
                                            className="step-button btn purple-btn min-height hvr-sweep-to-right me-3"
                                            data-bs-toggle="modal"
                                            data-bs-target="#Print-label"
                                            onClick={() =>
                                              handleOpenSinglePrint(ord)
                                            }
                                          >
                                            1. Print Label
                                          </a>
                                          <a className="step-button btn pink-btn min-height me-3 disbled-btn">
                                            2. Order Ready
                                          </a>
                                        </>
                                      )}
                                      {/* {ord.status === 1 ? (
                                        <a
                                          className="step-button btn min-height purple-btn hvr-sweep-to-right"
                                          onClick={() => completeed(ord._id, 2)}
                                        >
                                          3. Order Pick-Up Completed
                                        </a>
                                      ) : (
                                        <a className="step-button btn min-height disbled-btn">
                                          3. Order Pick-Up Completed
                                        </a>
                                      )} */}
                                      <a
                                        className={`step-button btn min-height ms-auto ${ord.userId.userType === "guestUser"
                                          ? "disbled-btn"
                                          : "purple-btn hvr-sweep-to-right"
                                          }`}
                                        style={{
                                          pointerEvents:
                                            ord.userId.userType === "guestUser"
                                              ? "none"
                                              : "auto",
                                        }}
                                        onClick={() =>
                                          ord.userId.userType !== "guestUser" &&
                                          handleChat(ord)
                                        }
                                      >
                                        Message Customer
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                ))}
              </div>

              {/* // For Food Preparation (UNCHANGED) */}
              <div
                className={
                  "tab-pane fade" + (type === "food" ? " show active" : "")
                }
                id="food-preparation"
                role="tabpanel"
                aria-labelledby="tab-3"
              >
                {Object.entries(
                  food.reduce((acc, ord) => {
                    ord.data.forEach((dish) => {
                      const window = dish.deliveryOrPickupWindow;
                      const date = moment(ord._id).format("Do MMM YYYY");

                      if (!acc[date]) {
                        acc[date] = {};
                      }

                      if (!acc[date][window]) {
                        acc[date][window] = [];
                      }

                      acc[date][window].push(dish);
                    });
                    return acc;
                  }, {})
                ).map(([date, windows]) => (
                  <div key={date} className="scheduled-date-group">
                    {Object.entries(windows)
                      .sort(([a], [b]) => {
                        if (a === "10am-1pm") return -1;
                        if (b === "10am-1pm") return 1;
                        if (a === "4pm-7pm") return 1;
                        if (b === "4pm-7pm") return -1;
                        return 0;
                      })
                      .map(([window, orders]) => (
                        <div
                          key={window}
                          className="delivery-pickup-window-group"
                        >
                          <div className="my-order-title mt-5">
                            <h3
                              className="my-orders-title"
                              style={{
                                fontSize: "17px",
                                fontWeight: "bold",
                              }}
                            >
                              {date}
                              &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              {window === "10am-1pm" ? "Lunch" : "Dinner"}
                              &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
                              Delivery&nbsp;/&nbsp;Pick-Up Window: {window}
                            </h3>
                          </div>

                          {orders
                            .reduce((resultArray, item, index) => {
                              const chunkIndex = Math.floor(index / 4);

                              if (!resultArray[chunkIndex]) {
                                resultArray[chunkIndex] = [];
                              }

                              resultArray[chunkIndex].push(item);
                              return resultArray;
                            }, [])
                            .map((chunk, chunkIndex) => (
                              <div className="without-tabs" key={chunkIndex}>
                                <div className="dish-head">
                                  <h5>Dishes:</h5>
                                </div>
                                <ul className="Dishes-list dishes-list-edit">
                                  {chunk.map((da, i) => (
                                    <li key={i}>
                                      <figure className="Dishes-list-L">
                                        <img
                                          src={ImageURL + da?.dishImage}
                                          alt={da?.dishName}
                                        />
                                      </figure>
                                      <figcaption className="Dishes-list-R">
                                        <h4>{da?.dishName}</h4>
                                        <span className="pb-2">
                                          <b>Qty:</b> {da?.dishQty}
                                        </span>
                                        <br />
                                        <span>
                                          <b>Time:</b>{" "}
                                          {da.deliveryOrPickupWindow}
                                        </span>
                                      </figcaption>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                        </div>
                      ))}
                  </div>
                ))}
              </div>
              {/* //For Completed orders */}
              <div
                className={
                  "tab-pane fade" + (type === "completed" ? " show active" : "")
                }
                id="completed-orders"
                role="tabpanel"
                aria-labelledby="tab-4"
              >
                {completedOrder.map((com, index) => (
                  <div className="accordion dash-accordion" id="completedOrder">
                    <h3 className="my-orders-title">
                      {moment(new Date(com?.orderDeliveryDate)).format(
                        "Do MMM YYYY"
                      )}
                    </h3>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={"#collapseOne" + index}
                          aria-expanded="true"
                          aria-controls={"collapseOne" + index}
                        >
                          <div className="dish-head">
                            <div className="title-timer">
                              <small>
                                #{com?.orderId} <b> {com?.orderPortion}</b>
                              </small>
                            </div>
                          </div>
                          <ul className="Dishes-list dishes-list-edit">
                            {com.dishData.map((co) => (
                              <li>
                                <figure className="Dishes-list-L">
                                  <img src={ImageURL + co?.dishId?.dishImage} />
                                </figure>
                                <figcaption className="Dishes-list-R">
                                  <h4>{co?.dishName}</h4>
                                  <span className="pb-2">
                                    <b>Qty:</b> {co?.qty}
                                  </span>
                                  <br />
                                  <span>
                                    <b>Type:</b> {com?.orderType}
                                  </span>
                                </figcaption>
                              </li>
                            ))}
                          </ul>
                        </button>
                      </h2>
                      <div
                        id={"collapseOne" + index}
                        className="accordion-collapse collapse show"
                        aria-labelledby={"headingOne" + index}
                        data-bs-parent="#completedOrder"
                      >
                        <div className="accordion-body">
                          <ul className="Delivery-content">
                            <li style={{ listStyleType: "none" }}>
                              <b>Delivery Preference:</b>
                              {com?.deliveryPreference}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Delivery / Pick up Window:</b>
                              {com.deliveryOrPickupWindow}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Customer Name:</b>
                              {com?.userId?.fullName}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Order Delivered Date :</b>
                              {moment(com.orderDeliveryDate).format(
                                "DD MMM YYYY"
                              )}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Spice Level:</b> {com.spiceLevel}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Spice Level:</b> {com.spiceLevel}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Order Instructions:</b> {com.orderInstructions}
                            </li>
                          </ul>
                          <div className="mt-4 d-flex three-combine-btn">
                            <NavLink
                              className=" btn purple-btn min-height hvr-sweep-to-right  me-3"
                              to={`/dashboard/viewdetails/${com?._id}`}
                              state={{ type: currentTab }}
                            >
                              View Details
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* //For Canceled orders */}
              <div
                className={
                  "tab-pane fade" + (type === "canceled" ? " show active" : "")
                }
                id="completed-orders"
                role="tabpanel"
                aria-labelledby="tab-4"
              >
                {canceledOrder.map((cancel, index) => (
                  <div className="accordion dash-accordion" id="canceledOrder">
                    <h3 className="my-orders-title">
                      {moment(new Date(cancel?.orderDeliveryDate)).format(
                        "Do MMM YYYY"
                      )}
                    </h3>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={"#collapseOne" + index}
                          aria-expanded="true"
                          aria-controls={"collapseOne" + index}
                        >
                          <div className="dish-head">
                            <div className="title-timer">
                              <small>
                                #{cancel?.orderId}{" "}
                                <b> {cancel?.orderPortion}</b>
                              </small>
                            </div>
                          </div>
                          <ul className="Dishes-list dishes-list-edit">
                            {cancel?.dishData.map((co) => (
                              <li>
                                <figure className="Dishes-list-L">
                                  <img src={ImageURL + co?.dishId?.dishImage} />
                                </figure>
                                <figcaption className="Dishes-list-R">
                                  <h4>{co?.dishName}</h4>
                                  <span className="pb-2">
                                    <b>Qty:</b> {co?.qty}
                                  </span>
                                  <br />
                                  <span>
                                    <b>Type:</b> {cancel?.orderType}
                                  </span>
                                </figcaption>
                              </li>
                            ))}
                          </ul>
                        </button>
                      </h2>
                      <div
                        id={"collapseOne" + index}
                        className="accordion-collapse collapse show"
                        aria-labelledby={"headingOne" + index}
                        data-bs-parent="#canceledOrder"
                      >
                        <div className="accordion-body">
                          <ul className="Delivery-content">
                            <li style={{ listStyleType: "none" }}>
                              <b>Delivery Preference:</b>
                              {cancel?.deliveryPreference}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Delivery / Pick up Window:</b>
                              {cancel?.deliveryOrPickupWindow}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Customer Name:</b>
                              {cancel?.userId?.fullName}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Spice Level:</b>{" "}
                              {cancel.spiceLevel}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Spice Level:</b> {cancel.spiceLevel}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Order Instructions:</b>{" "}
                              {cancel.orderInstructions}
                            </li>
                            {cancel?.cancelDate && (
                              <li style={{ listStyleType: "none" }}>
                                <b>Order Cancelation Date :</b>
                                {moment(cancel?.cancelDate).format(
                                  "DD MMM YYYY"
                                )}
                              </li>
                            )}
                          </ul>
                          <div className="mt-4 d-flex three-combine-btn">
                            <NavLink
                              className=" btn purple-btn min-height hvr-sweep-to-right  me-3"
                              to={`/dashboard/viewdetails/${cancel?._id}`}
                              state={{ type: currentTab }}
                            >
                              View Details
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> </>
    )}
          </div>

          {currentTab !== "open" && currentTab !== "delivery" && (
            <Pagination
              currentPage={currentPage}
              postsPerPage={PostPerPage}
              totalPosts={totalData}
              paginate={(pageNumber) => {
                paginate(pageNumber);
              }}
              onNext={onNext}
              onPrevious={onPrevious}
            />
          )}
        </div>
      </div>

      <Dialog
        open={print.show}
        maxWidth={print.data.length > 1 ? "md" : "sm"}
        fullWidth={print.data.length > 1}
        PaperProps={{
          style: { borderRadius: "15px", padding: "10px" },
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 20px",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              textTransform: "uppercase",
              color: "#4d4d4dff",
              letterSpacing: "0.5px",
            }}
          >
            Print Preview ({print.data.length}{" "}
            {print.data.length === 1 ? "label" : "labels"})
          </span>
          <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <i
              className="ri-printer-line"
              title="Confirm Print"
              onClick={() => triggerPrintWindow(print.data)}
              style={{ fontSize: "22px", cursor: "pointer", color: "#555" }}
            ></i>
            <i
              className="ri-close-line"
              title="Close"
              onClick={handleClickClose}
              style={{ fontSize: "24px", cursor: "pointer", color: "#555" }}
            ></i>
          </div>
        </div>

        <div
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
            padding: "20px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {print.data.length === 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {print.data.map((ord, idx) => (
                <div
                  key={idx}
                  className="label-card-preview"
                  style={{
                    textAlign: "left",
                    border: "2px dashed #5c5c5cff",
                    borderRadius: "12px",
                    padding: "20px",
                    background: "#fff",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                    width: "100%",
                    maxWidth: "420px",
                    boxSizing: "border-box",
                  }}
                >
                  <div className="text-center mb-2">
                    <figure>
                      <img
                        src={LogoImage}
                        style={{ height: "60px" }}
                        alt="Logo"
                      />
                    </figure>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                      Order #: {ord.orderId}
                    </span>
                    <span
                      style={{
                        background: "#ee2982",
                        color: "#fff",
                        padding: "3px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {ord.deliveryPreference}
                    </span>
                  </div>
                  <h2
                    style={{
                      fontSize: "24px",
                      fontWeight: "800",
                      marginTop: "22px",
                      marginBottom: "5px",
                      textAlign: "center",
                    }}
                  >
                    {ord.userId?.fullName}
                  </h2>

                  <hr
                    style={{
                      border: "none",
                      borderTop: "2px solid #5c5c5cff",
                      margin: "15px 0",
                      opacity: 1,
                    }}
                  />

                  <div style={{ fontSize: "14px", lineHeight: "1.4" }}>
                    <p style={{ marginBottom: "5px" }}>
                      <strong>Delivery Address:</strong> {ord.userAddress?.add1}
                      , {ord.userAddress?.city}, {ord.userAddress?.zip}
                    </p>
                    <div style={{ marginTop: "5px" }}>
                      <span>
                        <strong>Date:</strong>{" "}
                        {moment(ord.dishData[0].scheduledDate).format(
                          "Do MMM YYYY"
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "5px",
                      }}
                    >
                      <span>
                        <strong>Delivery Time:</strong>{" "}
                        {ord.deliveryOrPickupWindow}
                      </span>
                    </div>

                    <p style={{ marginTop: "5px" }}>
                      <strong>Phone: </strong>{" "}
                      {ord.userId?.phoneNumber || "N/A"}
                    </p>
                  </div>

                  <hr
                    style={{
                      border: "none",
                      borderTop: "2px solid #5c5c5cff",
                      margin: "10px 0",
                      opacity: 1,
                    }}
                  />

                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      <strong>Order Details</strong>
                    </h6>
                    <p>Chef: {ord.chefId?.firstName}</p>
                    <div
                      style={{
                        borderRadius: "10px",
                        overflow: "hidden",
                        border: "1px solid #5c5c5cff",
                        width: "100%",
                        marginTop: "5px",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "13px",
                        }}
                      >
                        <thead style={{ background: "#f4edf1" }}>
                          <tr style={{ borderBottom: "1px solid #5c5c5cff" }}>
                            <th style={{ padding: "5px", textAlign: "left" }}>
                              Dish Name
                            </th>
                            <th style={{ padding: "5px", textAlign: "right" }}>
                              Quantity
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ord.dishData.map((dish, i) => (
                            <tr
                              key={i}
                              style={{ borderBottom: "1px solid #5c5c5cff" }}
                            >
                              <td style={{ padding: "5px" }}>
                                {dish.dishName}
                              </td>
                              <td
                                style={{ padding: "5px", textAlign: "right" }}
                              >
                                {dish.qty}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "15px",
                      background: "#f4edf1",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "13px" }}>
                      Thank you for your order! Enjoy your meal 🍽️
                    </p>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <small style={{ fontWeight: "bold" }}>
                      www.WannaEat.com
                    </small>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
            >
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {print.data
                  .filter((_, i) => i % 2 === 0)
                  .map((ord, idx) => (
                    <div
                      key={idx}
                      className="label-card-preview"
                      style={{
                        textAlign: "left",
                        border: "2px dashed #5c5c5cff",
                        borderRadius: "12px",
                        padding: "20px",
                        background: "#fff",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div className="text-center mb-2">
                        <figure>
                          <img
                            src={LogoImage}
                            style={{ height: "60px" }}
                            alt="Logo"
                          />
                        </figure>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                          Order #: {ord.orderId}
                        </span>
                        <span
                          style={{
                            background: "#ee2982",
                            color: "#fff",
                            padding: "3px 10px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {ord.deliveryPreference}
                        </span>
                      </div>
                      <h2
                        style={{
                          fontSize: "24px",
                          fontWeight: "800",
                          marginTop: "22px",
                          marginBottom: "5px",
                          textAlign: "center",
                        }}
                      >
                        {ord.userId?.fullName}
                      </h2>

                      <hr
                        style={{
                          border: "none",
                          borderTop: "2px solid #5c5c5cff",
                          margin: "15px 0",
                          opacity: 1,
                        }}
                      />

                      <div style={{ fontSize: "14px", lineHeight: "1.4" }}>
                        <p style={{ marginBottom: "5px" }}>
                          <strong>Delivery Address:</strong>{" "}
                          {ord.userAddress?.add1}, {ord.userAddress?.city},{" "}
                          {ord.userAddress?.zip}
                        </p>
                        <div style={{ marginTop: "5px" }}>
                          <span>
                            <strong>Date:</strong>{" "}
                            {moment(ord.dishData[0].scheduledDate).format(
                              "Do MMM YYYY"
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "5px",
                          }}
                        >
                          <span>
                            <strong>Delivery Time:</strong>{" "}
                            {ord.deliveryOrPickupWindow}
                          </span>
                        </div>

                        <p style={{ marginTop: "5px" }}>
                          <strong>Phone: </strong>{" "}
                          {ord.userId?.phoneNumber || "N/A"}
                        </p>
                      </div>

                      <hr
                        style={{
                          border: "none",
                          borderTop: "2px solid #5c5c5cff",
                          margin: "10px 0",
                          opacity: 1,
                        }}
                      />

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          <strong>Order Details</strong>
                        </h6>
                        <p>Chef: {ord.chefId?.firstName}</p>
                        <div
                          style={{
                            borderRadius: "10px",
                            overflow: "hidden",
                            border: "1px solid #5c5c5cff",
                            width: "100%",
                            marginTop: "5px",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: "13px",
                            }}
                          >
                            <thead style={{ background: "#f4edf1" }}>
                              <tr
                                style={{ borderBottom: "1px solid #5c5c5cff" }}
                              >
                                <th
                                  style={{ padding: "5px", textAlign: "left" }}
                                >
                                  Dish Name
                                </th>
                                <th
                                  style={{ padding: "5px", textAlign: "right" }}
                                >
                                  Quantity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ord.dishData.map((dish, i) => (
                                <tr
                                  key={i}
                                  style={{
                                    borderBottom: "1px solid #5c5c5cff",
                                  }}
                                >
                                  <td style={{ padding: "5px" }}>
                                    {dish.dishName}
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {dish.qty}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "15px",
                          background: "#f4edf1",
                          padding: "10px",
                          borderRadius: "8px",
                        }}
                      >
                        <p style={{ margin: 0, fontSize: "13px" }}>
                          Thank you for your order! Enjoy your meal 🍽️
                        </p>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <small style={{ fontWeight: "bold" }}>
                          www.WannaEat.com
                        </small>
                      </div>
                    </div>
                  ))}
              </div>

              {/* RIGHT COLUMN: Contains items at index 1, 3, 5... */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {print.data
                  .filter((_, i) => i % 2 !== 0)
                  .map((ord, idx) => (
                    <div
                      key={idx}
                      className="label-card-preview"
                      style={{
                        textAlign: "left",
                        border: "2px dashed #5c5c5cff",
                        borderRadius: "12px",
                        padding: "20px",
                        background: "#fff",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div className="text-center mb-2">
                        <figure>
                          <img
                            src={LogoImage}
                            style={{ height: "60px" }}
                            alt="Logo"
                          />
                        </figure>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                          Order #: {ord.orderId}
                        </span>
                        <span
                          style={{
                            background: "#ee2982",
                            color: "#fff",
                            padding: "3px 10px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {ord.deliveryPreference}
                        </span>
                      </div>
                      <h2
                        style={{
                          fontSize: "24px",
                          fontWeight: "800",
                          marginTop: "22px",
                          marginBottom: "5px",
                          textAlign: "center",
                        }}
                      >
                        {ord.userId?.fullName}
                      </h2>

                      <hr
                        style={{
                          border: "none",
                          borderTop: "2px solid #5c5c5cff",
                          margin: "15px 0",
                          opacity: 1,
                        }}
                      />

                      <div style={{ fontSize: "14px", lineHeight: "1.4" }}>
                        <p style={{ marginBottom: "5px" }}>
                          <strong>Delivery Address:</strong>{" "}
                          {ord.userAddress?.add1}, {ord.userAddress?.city},{" "}
                          {ord.userAddress?.zip}
                        </p>
                        <div style={{ marginTop: "5px" }}>
                          <span>
                            <strong>Date:</strong>{" "}
                            {moment(ord.dishData[0].scheduledDate).format(
                              "Do MMM YYYY"
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "5px",
                          }}
                        >
                          <span>
                            <strong>Delivery Time:</strong>{" "}
                            {ord.deliveryOrPickupWindow}
                          </span>
                        </div>

                        <p style={{ marginTop: "5px" }}>
                          <strong>Phone: </strong>{" "}
                          {ord.userId?.phoneNumber || "N/A"}
                        </p>
                      </div>

                      <hr
                        style={{
                          border: "none",
                          borderTop: "2px solid #5c5c5cff",
                          margin: "10px 0",
                          opacity: 1,
                        }}
                      />

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          <strong>Order Details</strong>
                        </h6>
                        <p>Chef: {ord.chefId?.firstName}</p>
                        <div
                          style={{
                            borderRadius: "10px",
                            overflow: "hidden",
                            border: "1px solid #5c5c5cff",
                            width: "100%",
                            marginTop: "5px",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: "13px",
                            }}
                          >
                            <thead style={{ background: "#f4edf1" }}>
                              <tr
                                style={{ borderBottom: "1px solid #5c5c5cff" }}
                              >
                                <th
                                  style={{ padding: "5px", textAlign: "left" }}
                                >
                                  Dish Name
                                </th>
                                <th
                                  style={{ padding: "5px", textAlign: "right" }}
                                >
                                  Quantity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ord.dishData.map((dish, i) => (
                                <tr
                                  key={i}
                                  style={{
                                    borderBottom: "1px solid #5c5c5cff",
                                  }}
                                >
                                  <td style={{ padding: "5px" }}>
                                    {dish.dishName}
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {dish.qty}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "15px",
                          background: "#f4edf1",
                          padding: "10px",
                          borderRadius: "8px",
                        }}
                      >
                        <p style={{ margin: 0, fontSize: "13px" }}>
                          Thank you for your order! Enjoy your meal 🍽️
                        </p>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <small style={{ fontWeight: "bold" }}>
                          www.WannaEat.com
                        </small>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default NewOrder;